import React, {PureComponent} from 'react'
import {connect} from'react-redux'
import injectSheet from 'react-jss'
import cn from 'classnames'
import chevronImage from "../../img/icons/chevron.svg"
import SVGSymbol from "../SVGSymbol"
import Checkbox from './Checkbox'
import {openDropdown, closeDropdown} from "../../actions"
import Transition from 'react-transition-group/Transition';
import {TweenLite} from 'gsap'
import {canUseDom} from "../../utils/dom"

const TRANSITION_DURATION_SECONDS = 0.3;

class DropDown extends PureComponent {

    componentWillMount() {
        if(canUseDom) document.addEventListener('click', this._onOutsideClick, false);
    }

    componentWillUnmount() {
        if(canUseDom) document.removeEventListener('click', this._onOutsideClick, false);
    }

    _onOutsideClick = (e) => {
        const {open, id, handleClose} = this.props
        if(!open) return;
        handleClose(id);
    }

    _onClick = (e) => {
        const {open, id, handleClose, handleOpen} = this.props
        if(open) handleClose(id);
        else handleOpen(id);
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    _onCheckChanged = (e, checked, value) => {
        const {selectedValues, onChange} = this.props;
        if(checked) onChange([ ...selectedValues, value ]);
        if(!checked) {
            const index = selectedValues.indexOf(value)
            onChange( [
                ...selectedValues.slice(0, index),
                ...selectedValues.slice(index + 1)
            ])
        }
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    _onExiting = (node) => {
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {opacity: 0, display: 'none'})
    }

    _onEntering = (node) => {
        TweenLite.set(node, {display: 'block'})
        TweenLite.set(node, {minWidth: this._ref.clientWidth})
        TweenLite.to(node, TRANSITION_DURATION_SECONDS, {opacity: 1})
    }

    _setRef = (ref) => this._ref = ref;

    render() {
        const {classes, className, label, selectedValues, options, open, dropDownClassName} = this.props;

        return <div onClick={this._onClick} className={cn(classes.container, className, {open, selected: selectedValues && selectedValues.length})} ref={this._setRef}>
                <div className={classes.title}>{label}<SVGSymbol icon={chevronImage} className={cn(classes.icon, {open})} /></div>
                <Transition in={open} timeout={TRANSITION_DURATION_SECONDS*1000} onEntering={this._onEntering} onExiting={this._onExiting}>
                    {(state) => ( <div className={cn(classes.listContainer, dropDownClassName)}>
                        <div className={classes.divider}></div>
                        <ul className={cn(classes.list)}>
                        {options && options.map(option => <li key={option}>
                            <Checkbox label={option} iconPlacement='left'
                                      className={classes.listItem}
                                      iconClassName={classes.listItemIcon}
                                      checked={selectedValues.indexOf(option) >= 0} value={option}
                                      onChange={this._onCheckChanged}/></li>)}
                    </ul></div>)}
                </Transition>
            </div>

    }
}

const mapStateToProps = (state, props) => {
    return {
        open: state.dropdown.open && state.dropdown.id === props.id,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleOpen: ( id ) => {
            dispatch(openDropdown(id))
        },
        handleClose: ( id ) => {
            dispatch(closeDropdown(id))
        },
    }
}

export default injectSheet( (theme) => ({
    container:{
        cursor: 'pointer',
        position: 'relative',
        minWidth: 130,
        transition: `backgroundColor ${TRANSITION_DURATION_SECONDS}s ease-in-out`,
        "&:hover": {
            color: theme.colors.primary
        },
        ...theme.font.title.h4,
        '&.open, &.selected': {
            color: theme.colors.primary,
        },
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        zIndex: theme.zIndex.dropdown + 1,
    },
    icon: {
        marginLeft: theme.spacing.tiny,
        transition: `transform ${TRANSITION_DURATION_SECONDS}s ease-in-out`,
        '&.open': {
            transform: 'rotate(180deg)',
        }
    },
    listContainer: {
        position: 'absolute',
        top: 0,
        paddingTop: 52,
        left: 0,
        minWidth: 130,
        opacity: 0,
        display: 'none',
        zIndex: theme.zIndex.dropdown,
        backgroundColor: theme.colors.white,

    },
    list: {
        listStyle: 'none',
        padding: '10px 0 10px',
        margin: '0',
        maxHeight: 200,
        overflowY: 'auto',
    },
    listItem: {
        padding: 5,
        color: theme.colors.black,
        fontFamily: theme.font.family,
        fontSize: '12px',
        fontWeight: "200",
        lineHeight: 1.8,
        "&.color": {
            color: theme.colors.primary
        },
        "& > svg": {
            margin: '-1px 10px 0'
        }
    },
    listItemIcon: {
        width: 8,
        height: 8
    },
    divider: {
        backgroundColor: theme.colors.divider,
        height: 1,
        display: 'block',
        margin: '0 10px'
    }
}))(connect(mapStateToProps, mapDispatchToProps)(DropDown))





// WEBPACK FOOTER //
// ./src/components/Widgets/DropDown.js